document.addEventListener('DOMContentLoaded', function () {

  // ===== IMAGE SLIDER (per-section fix) =====
  document.querySelectorAll('.cpap-slider').forEach(function(slider) {
    const slides = slider.querySelectorAll('.cpap-slide');
    const container = slider.closest('.cpap-hero__left');
    const thumbs = container ? container.querySelectorAll('.cpap-thumb') : [];
    let current = 0;

    function goToSlide(index) {
      slides[current].classList.remove('active');
      if (thumbs[current]) thumbs[current].classList.remove('active');
      current = (index + slides.length) % slides.length;
      slides[current].classList.add('active');
      if (thumbs[current]) thumbs[current].classList.add('active');
    }

    slider.querySelector('.cpap-slide-prev')?.addEventListener('click', () => goToSlide(current - 1));
    slider.querySelector('.cpap-slide-next')?.addEventListener('click', () => goToSlide(current + 1));

    thumbs.forEach((thumb, i) => {
      thumb.addEventListener('click', () => goToSlide(i));
    });
  });

  // ===== QUANTITY STEPPER =====
  document.querySelectorAll('.cpap-section').forEach(function(section) {
    const qtyInput  = section.querySelector('.cpap-qty-input');
    const qtyHidden = section.querySelector('.cpap-qty-hidden');

    section.querySelector('.cpap-qty-plus')?.addEventListener('click', () => {
      let v = parseInt(qtyInput.value) || 1;
      if (v < 99) { qtyInput.value = v + 1; if (qtyHidden) qtyHidden.value = v + 1; }
    });
    section.querySelector('.cpap-qty-minus')?.addEventListener('click', () => {
      let v = parseInt(qtyInput.value) || 1;
      if (v > 1) { qtyInput.value = v - 1; if (qtyHidden) qtyHidden.value = v - 1; }
    });
  });

});
